"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Ahti_logo_png_1 = __importDefault(require("../../../images/Ahti_logo.png"));
const styled_components_1 = __importDefault(require("styled-components"));
const theme_1 = require("../../theme");
const routes_1 = require("../../util/routes");
const NavigationContext_1 = require("../../contexts/NavigationContext");
const Logo = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
`;
const LogoImage = styled_components_1.default.img `
  width: 200px;
  height: auto;
  margin-bottom: -20px;
`;
const LogoText = styled_components_1.default.div `
  font-weight: bold;
  font-size: 20px;
  letter-spacing: 2px;
  color: ${theme_1.theme.colors.text};
`;
const AhtiLogo = ({ style }) => {
    const { navigate } = (0, NavigationContext_1.useNavigation)();
    return ((0, jsx_runtime_1.jsxs)(Logo, { style: {
            ...style,
        }, onClick: (e) => {
            e.preventDefault();
            navigate(routes_1.routeNames.main);
        }, children: [(0, jsx_runtime_1.jsx)(LogoImage, { src: Ahti_logo_png_1.default, alt: "Ahti Logo" }), (0, jsx_runtime_1.jsx)(LogoText, { children: "CALCULATOR" })] }));
};
exports.default = AhtiLogo;
